// src/services/interviewAPI.js
import { API_BASE_URL, getAuthHeaders as getAuthHeadersBase } from '../../config/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
    return getAuthHeadersBase();
  };

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(errorData.error || errorData.message || 'Request failed');
  }
  const data = await response.json();
  console.log('✅ API Response:', data);
  return data;
};

// CREATE - Create new interview session
export const createInterviewAPI = async (interviewData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/create`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(interviewData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Create interview error:', error);
    throw error;
  }
};

// READ - Get all interviews for authenticated user
export const getInterviewsAPI = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get interviews error:', error);
    throw error;
  }
};

// READ - Get single interview by ID
export const getInterviewByIdAPI = async (interviewId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/${interviewId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get interview by ID error:', error);
    throw error;
  }
};

// READ - Get interview by session ID
export const getInterviewBySessionAPI = async (sessionId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/session/${sessionId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get interview by session error:', error);
    throw error;
  }
};

// UPDATE - Update interview configuration
export const updateInterviewAPI = async (interviewId, updateData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/${interviewId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(updateData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Update interview error:', error);
    throw error;
  }
};

// UPDATE - Submit interview results
export const submitInterviewResultsAPI = async (interviewId, resultsData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/${interviewId}/results`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(resultsData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Submit interview results error:', error);
    throw error;
  }
};

// UPDATE - Update interview status
export const updateInterviewStatusAPI = async (interviewId, status) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/${interviewId}/status`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ status }),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Update interview status error:', error);
    throw error;
  }
};

// DELETE - Delete interview session
export const deleteInterviewAPI = async (interviewId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/${interviewId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Delete interview error:', error);
    throw error;
  }
};

// GET - Get interview statistics
export const getInterviewStatisticsAPI = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/interview/statistics`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get interview statistics error:', error);
    throw error;
  }
};

// Helper function to handle API errors
export const handleAPIError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.message || 'An unexpected error occurred',
    status: 0,
  };
};
